import React from 'react';
import { motion } from 'framer-motion';
import * as Icons from 'lucide-react';
import { services } from '../mock';

export const Services = () => {
  const getIcon = (iconName) => {
    const IconComponent = Icons[iconName.split('-').map((word, index) =>
      index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) :
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join('').replace(/-/g, '')] || Icons.Code;
    return IconComponent;
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-blue-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center space-y-4 mb-16"
        >
          <span className="inline-block px-4 py-2 bg-[#2196F3]/10 text-[#2196F3] rounded-full text-sm font-semibold">
            Our Services
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#071B4D]">
            Comprehensive Technology Solutions
          </h2>
          <p className="max-w-3xl mx-auto text-lg text-gray-600">
            From AI innovation to cloud infrastructure, we provide end-to-end
            technology solutions tailored to your business needs.
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {services.map((service) => {
            const IconComponent = getIcon(service.icon);
            return (
              <motion.div
                key={service.id}
                variants={cardVariants}
                whileHover={{ y: -8, scale: 1.02 }}
                className="group relative p-6 bg-white/60 backdrop-blur-sm rounded-2xl border border-gray-200 hover:border-[#2196F3] transition-all duration-300 shadow-lg hover:shadow-2xl overflow-hidden"
              >
                {/* Glow Effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#2196F3]/0 to-[#2196F3]/0 group-hover:from-[#2196F3]/5 group-hover:to-[#071B4D]/5 transition-all duration-300 rounded-2xl" />

                <div className="relative space-y-4">
                  <div className="w-12 h-12 bg-[#2196F3]/10 rounded-xl flex items-center justify-center group-hover:bg-[#2196F3] group-hover:scale-110 transition-all duration-300">
                    <IconComponent className="w-6 h-6 text-[#2196F3] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-xl font-bold text-[#071B4D] group-hover:text-[#2196F3] transition-colors duration-300">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};